import { AfterContentChecked, AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import moment from "moment-timezone";
import {
  ArkUserType,
  UserModel,
  JwTokenModel,

  ServerStatusViewModel,
  ServiceStatusViewModel,
  StatusCode,
  WebSiteStatusViewModel,
  WebUrlViewModel
} from "../../core/api/models";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { DeveloperApiService } from "../../core/api/services";
import { DomSanitizer } from "@angular/platform-browser";
import { LegendPosition } from "@swimlane/ngx-charts";




@Component({
  selector: 'app-system-status-component',
  templateUrl: './system-status.component.html',
  styleUrl: './system-status.component.css',
  standalone: false
})
export class SystemStatusComponent implements OnInit, AfterContentChecked {

  @ViewChild('map') m: any = null;

  public pageTitle: string = 'System Status';

  notifications: Notification[] = [];
  timeout: any;
  lastStatusDate: string | null = null;
  lastStatusCode: StatusCode = StatusCode.None;

  failedMessage: string | null = null;
  failedSystem: string[] = [];
  warningSystem: string[] = [];
  warningMessage: string | null = null;



  isVisible: boolean = false;
  loadingServer: boolean = false;
  loadingService: boolean = false;
  loadingWebSite: boolean = false;
  loadingWebUrls: boolean = false;



  serverStatuses: ServerStatusViewModel[] | null | undefined;
  serviceStatuses: ServiceStatusViewModel[] | null | undefined;
  webSiteStatuses: WebSiteStatusViewModel[] | null | undefined;
  webUrls: WebUrlViewModel[] | null | undefined;

  legendPosition = LegendPosition.Below;
  webUrlsData: any[] = [];

  
  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: DeveloperApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {

    
    this.route.queryParams.subscribe(params => {
      let userId = +params['userId'];
    });


    this.authService.checkIfAutorized([ArkUserType.Developer, ArkUserType.Admin]);

    this.LoadStatus('on init');
    
  }

  get loading()  {

    return this.loadingServer
      || this.loadingService
      || this.loadingWebSite
      || this.loadingWebUrls;

  }
  ngAfterContentChecked(): void {
    if (this.m && this.m.nativeElement.offsetParent !== null) {
      this.isVisible = true;
    } else {
      this.isVisible = false
    }
    
  }

  DoReload() {

    if (Notification.permission === "default") {
      Notification.requestPermission().then((result) => {
        console.log(result);
      });
    }
    this.failedSystem = [];
    this.warningSystem = [];

    this.loadingServer = false;
    this.loadingService = false;
    this.loadingWebSite = false;
    this.loadingWebUrls = false;

    this.LoadStatus('by button');
  }

  LoadStatus(source: string) {

    if (this.loadingServer
      || this.loadingService
      || this.loadingWebSite
      || this.loadingWebUrls)
      return;

    this.loadingServer = true;
    this.loadingService = true;
    this.loadingWebSite = true;
    this.loadingWebUrls = true;

    console.debug('Loading Status '+  source);
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    this.apiService.ListWebUrls({
      body: {
        filters: {
          IsMonitored: [{
            Value: true,
            MatchMode: 'eq'
          }]
        }
      }
    })
      .forEach(data => {
        this.loadingWebUrls = false;
        this.webUrls = data.Result;

        if (this.webUrls) {

          var chartData: any[] = [];

          //var startTime = moment.tz(new Date(), 'America/Denver');
          
          for (var webUrl of this.webUrls) {

            if (!webUrl.StatusJson)
              continue;

            var itemData = JSON.parse(webUrl.StatusJson);

            if (!itemData.History || !itemData.History.length)
              continue;



            var itemTime = moment.tz(webUrl.RequestDate, 'America/Denver');

            if (environment.production
              && itemTime.utc().diff(moment.utc(), 'minutes') < -30) {
              continue;
            }
            
            var item = {
              name: webUrl.UrlName,
              series: [] as any[]
            };
            chartData.push(item);

            var timeStep = webUrl.MinPoolInterval ?? 30;
            var itemTime = itemTime.add( (itemData.History.length * -1 + 1) * timeStep, 'seconds');

            for (var historyItem of itemData.History) {
              
              item.series.push({
                value: (historyItem >= 0) ? historyItem : historyItem*-1,
                name: itemTime.toDate()//.format('ddd, MMMM Do, YYYY [at] h:mm:ss A')
              });
              itemTime = itemTime.add(timeStep, 'seconds');
            }
          }
          this.webUrlsData = chartData;
        }
        //console.debug(this.webUrlsData);
        this.FinishedLoading('#divWebUrls');

      }).catch(
        err => {
          this.loadingWebUrls = false;
          this.alertService.error(Utils.getAjaxError(err));
        });

    this.apiService.ListWebSiteStatuses({
        body: {
          filters: {
            IsMonitored: [{
              Value: true,
              MatchMode:'eq'
            }]
          }
        }
      })
      .forEach(data => {
        this.loadingWebSite = false;
        this.webSiteStatuses = data.Result;
        this.FinishedLoading('#divWebSites');

      }).catch(
        err => {
          this.loadingWebSite = false;
          this.alertService.error(Utils.getAjaxError(err));
        });

    this.apiService.ListServiceStatuses({
      body: {        
      }
    })
      .forEach(data => {
        this.loadingService = false;
        this.serviceStatuses = data.Result;
        this.FinishedLoading('#divServices');

      }).catch(
        err => {
          this.loadingService = false;
          this.alertService.error(Utils.getAjaxError(err));
        });

    this.apiService.ListServerStatuses({
      body: {        
      }
    })
      .forEach(data => {
        this.loadingServer = false;
        this.serverStatuses = data.Result;
        this.FinishedLoading('#divServers');
        
      }).catch(
        err => {
          this.loadingServer = false;
          this.alertService.error(Utils.getAjaxError(err));
        });
  }

  FinishedLoading(containerId: string | undefined = undefined): void {
    setTimeout(() => {
      $('.card-header-btn', containerId).click(function () {
        $(this).find('i').toggleClass('fa-angle-double-down fa-angle-double-up');
      });
    }, 1000);


    if (!this.loading) {

      
      // update overall status
      this.lastStatusDate = Utils.formatMountainTime(moment.tz(new Date(), 'America/Denver').toDate());
      
      let failed = [];
      let warnings = [];
      
      if (this.serverStatuses)
      {
        for (var server of this.serverStatuses) {

          if (this.IsOutdated(server)) {
            continue;
          }


          if (server.StatusCode === StatusCode.Fail) {
            if (this.failedSystem.indexOf(`Server ${server.MachineName}`) === -1) {
              this.failedSystem.push(`Server ${server.MachineName}`);
              this.showFailedMessage(`Server ${server.MachineName}: ${this.GetStatusText(server)}`);
            }
            failed.push(`${server.MachineName}: ${this.GetStatusText(server)}`);
          } else if (server.StatusCode === StatusCode.Warn) {
            if (this.warningSystem.indexOf(`Server ${server.MachineName}`) === -1) {
              this.warningSystem.push(`Server ${server.MachineName}`);
              this.alertService.warn(`Server ${server.MachineName}: ${this.GetStatusText(server)}`);
            }
            warnings.push(`${server.MachineName}: ${this.GetStatusText(server)}`);
          }
        }
      }
      if (this.serviceStatuses)
      {
        for (var service of this.serviceStatuses) {
          if (this.IsOutdated(service)) {
            continue;
          }

          if (service.StatusCode === StatusCode.Fail) {
            if (this.failedSystem.indexOf(`Service ${service.ServiceName}`) === -1) {
              this.failedSystem.push(`Service ${service.ServiceName}`);
              this.showFailedMessage(`Service ${service.ServiceName}: ${this.GetStatusText(service)}`);
            }
            failed.push(`${service.ServiceName}: ${this.GetStatusText(service)}`);
          } else if (service.StatusCode === StatusCode.Warn) {
            if (this.warningSystem.indexOf(`Service ${service.ServiceName}`) === -1) {
              this.warningSystem.push(`Service ${service.ServiceName}`);
              this.alertService.warn(`Service ${service.ServiceName}: ${this.GetStatusText(service)}`);
            }
            warnings.push(`${service.ServiceName}: ${this.GetStatusText(service)}`);
          }
        }
      }
      if (this.webSiteStatuses) {
        for (var webSite of this.webSiteStatuses) {

          if (this.IsOutdated(webSite)) {
            continue;
          }


          if (webSite.StatusCode === StatusCode.Fail) {
            if (this.failedSystem.indexOf(`WebSite ${webSite.SiteName}`) === -1)
            {
              this.failedSystem.push(`WebSite ${webSite.SiteName}`);
              this.showFailedMessage(`WebSite ${webSite.SiteName}: ${this.GetStatusText(webSite)}`);
            }
            failed.push(`${webSite.SiteName}: ${this.GetStatusText(webSite)}`);
          } else if (webSite.StatusCode === StatusCode.Warn) {
            if (this.warningSystem.indexOf(`WebSite ${webSite.SiteName}`) === -1) {
              this.warningSystem.push(`WebSite ${webSite.SiteName}`);
              this.alertService.warn(`WebSite ${webSite.SiteName}: ${this.GetStatusText(webSite)}`);
            }
            warnings.push(`${webSite.SiteName}: ${this.GetStatusText(webSite)}`);
          }
        }
      }
      if (this.webUrls) {
        for (var webUrl of this.webUrls) {
          if (this.IsWebUrlOutdated(webUrl)) {
            continue;
          }

          if (webUrl.StatusCode === StatusCode.Fail) {
            if (this.failedSystem.indexOf(`URL ${webUrl.UrlName}`) === -1) {
              this.failedSystem.push(`URL ${webUrl.UrlName}`);
              this.showFailedMessage(`URL ${webUrl.UrlName}: ${this.GetStatusText(webUrl)}`);
            }
            failed.push(`${webUrl.UrlName}: ${this.GetStatusText(webUrl)}`);
          } else if (webUrl.StatusCode === StatusCode.Warn) {
            if (this.warningSystem.indexOf(`URL ${webUrl.UrlName}`) === -1) {
              this.warningSystem.push(`URL ${webUrl.UrlName}`);
              this.alertService.warn(`URL ${webUrl.UrlName}: ${this.GetStatusText(webUrl)}`);
            }
            warnings.push(`${webUrl.UrlName}: ${this.GetStatusText(webUrl)}`);
          }
        }
      }

      this.failedMessage = failed.join('\n');
      this.warningMessage = warnings.join('\n');
      if (failed.length == 0) {
        this.failedSystem = [];
        this.notifications.forEach(n => n.close());
        this.notifications = [];
      }
      if (warnings.length == 0) {
        this.warningSystem = [];
      }

      if (failed.length > 0) {
        this.lastStatusCode = StatusCode.Fail;
      }
      else if (warnings.length > 0) {
        this.lastStatusCode = StatusCode.Warn;
      }
      else {
        this.lastStatusCode = StatusCode.Ok;

      }
      

      if (this.router.routerState.snapshot.url.toLowerCase() == '/systemstatus'
        && environment.production) {
        console.debug('Status Loaded. Will reload in 30 seconds');
        // only if this component is visible, otherwise wait until next time
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
          this.LoadStatus('on timer');
        }, 30000);
      } else {
        console.debug('Status Loaded. Current page is '+ this.router.routerState.snapshot.url);
      }
    }

  }

  showFailedMessage(message: string) {
    console.info('showFailedMessage', message);
    this.alertService.error(message);

    if (Notification.permission === "granted") {
      const notification = new Notification("System Alert",
        {
          //requireInteraction: true,
          body: message, icon: 'assets/icon-navy-32.png'
        });
      this.notifications.push(notification);
    }
    
    //ServiceWorkerRegistration.showNotification()
  }


  


  formatByteSize(value: any): string {
    if (value === null || value === undefined)
      return '-';

    return Utils.formatByteSize(value);
  }

  formatByteSizeMB(value: any): string {
    if (value === null || value === undefined)
      return '-';
     
    return Utils.formatByteSize(value * 1024 * 1024);
  }

  formatPercentage(value: any, total: any): string {
    if (value === null || value === undefined
    || total === null || total === undefined || total === 0)
      return '-';

    return ((value / total) * 100).toFixed(1) + '%';
  }


  getRuntime(value: any): string {
    if (value === null || value === undefined)
      return '-';
    var t = new Date(value);
    // convert value from Mountain Time to local time

    const mountainTime = moment.tz(value, 'America/Denver');

    //var localTime = moment(mountainTime).utc().tz(moment.tz.guess() || 'Local');

    return mountainTime.fromNow();


    var now = new Date();
    var diff = now.getTime() - t.getTime();
    var seconds = Math.floor(diff / 1000);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);

    return days + 'd ' + (hours % 24) + 'h ' + (minutes % 60) + 'm';
    
  }

  IsOutdated(item: ServerStatusViewModel |
    ServiceStatusViewModel |
    WebSiteStatusViewModel |
    null | undefined): boolean {
    if (!item || !item.Date)
      return false;

    if (!environment.production)
      return false;


    const time = moment.tz(item.Date, 'America/Denver').utc();

    if (time.diff(moment.utc(), 'minutes') > 2) {
      return true;
    }
    
    return false;
  }

  IsWebUrlOutdated(item:
    WebUrlViewModel |
    null | undefined): boolean {
    if (!item || !item.RequestDate)
      return false;

    const time = moment.tz(item.RequestDate, 'America/Denver').utc();

    if (time.diff(moment.utc(), 'minutes') > 2) {
      return true;
    }

    return false;
  }

  GetStatusColor(item: ServerStatusViewModel |
    ServiceStatusViewModel |
    WebSiteStatusViewModel |
    null | undefined): string {
    if (!item || item.StatusCode === undefined || item.StatusCode === null) {
      return 'info';
    }

    if (this.IsOutdated(item)) {
      return 'info';
    }

    switch (item.StatusCode) {
        case StatusCode.Ok:
          return 'success';
        case StatusCode.Fail:
          return 'danger';
        case StatusCode.None:
          return 'secondary';
        case StatusCode.Warn:
          return 'warning';
        default:
          return 'info';
      }
  }



  GetStatusText(item: ServerStatusViewModel |
    ServiceStatusViewModel |
    WebSiteStatusViewModel |
    null | undefined): string | null {
    if (!item || item.StatusCode === undefined || item.StatusCode === null) {
      //return 'Unknown';
      return null;
    }

    if (this.IsOutdated(item)) {
      return 'Outdated';
    } 
    let status = item.StatusMessage;
    
    if (!status || status.length == 0 || status.length >100) {
      switch (item.StatusCode) {
        case StatusCode.Ok:
          //status = 'OK';
          return null;
          break;
        case StatusCode.Fail:
          status = 'Fail';
          break;
        case StatusCode.None:
          return null;
          status = 'None';
          break;
        case StatusCode.Warn:
          status = 'Warn';
          break;
        default:
          return null;
          //status = 'Unknown';
      }
    }

    return status ||'';
  }


  onChartSelect(data: any): void {
    
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));

    this.alertService.info(`${data.series}: ${data.value}ms \r\n ${Utils.formatMountainTime(data.name)} `)
  }

  onChartActivate(data: any): void {
    //console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onChartDeactivate(data: any): void {
    //console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

}
